import QuantitySelectView from 'quantity-select.view';
import * as React from 'react';
import { connect } from 'react-redux';
import { IPriceType, PriceTypeOverrideType } from '../../custom/classes/production';
import { IPackageListingAppState } from '../../redux-state';
import { updatePriceTypeQuantity, clearPriceTypeQuantities, getUnseatedFlexPricingFromPt } from '../../redux-state/actions/package-listing.actions';
import { flatMap, uniqBy } from 'lodash';
import { PackageType } from '../../classes/package-listing';


interface StateToProps {
    packagePriceTypes: Array<IPriceType>;
    selectedPriceTypeQuantities: Map<number, number>;
    selectTicketsText: string;
    isFlex: boolean;
    isRenewal: boolean;
}

interface DispatchToProps {
    selectPriceTypeQuantity: (priceTypeId, quantity) => void;
    resetPriceTypeQuantities: () => void;
}

export type QuantitySelectProps = StateToProps & DispatchToProps;


export class QuantitySelectBase extends React.Component<QuantitySelectProps, any> {
    static DEFAULT_FLEX_AMOUNT = 1;

    constructor(props: QuantitySelectProps) {
        super(props);

        if (this.props.isFlex) {
            this.props.packagePriceTypes.forEach(packagePriceType => {
                this.props.selectPriceTypeQuantity(packagePriceType.priceTypeId, QuantitySelectBase.DEFAULT_FLEX_AMOUNT);
            })
        }
        else if (this.props.packagePriceTypes.length == 1) {
            this.props.selectPriceTypeQuantity(this.props.packagePriceTypes[0].priceTypeId, 1);
        }
    }

    componentDidMount() {
        if (this.props.selectPriceTypeQuantity.length == 0) {
            // reset state again because of browser state being loaded and react not knowing how to handle it
            setTimeout(() => this.props.resetPriceTypeQuantities());
        }
    }

    render() {
        return <QuantitySelectView {...this.props} {...this.state} />;
    }
}

function mapStateToProps(state: IPackageListingAppState): StateToProps {
    const priceTypeOverrideType = state.packageListingSettings.isRenewal
        ? PriceTypeOverrideType.RENEWAL
        : PriceTypeOverrideType.ACQUISTION;

    return {
        selectTicketsText: state.packageListingText.selectTicketsTitle,
        selectedPriceTypeQuantities: state.packageListing.priceTypeQuantity,
        isFlex: state.packageListing?.packageDetail?.packageType === PackageType.Flex,
        isRenewal: state.packageListingSettings.isRenewal,
        packagePriceTypes: state.packageListingSettings.isFixed
            ? uniqBy(
                flatMap(
                    state.packageListing.packages.map(pkg => pkg.priceTypeOverrideDictionary[priceTypeOverrideType])
                ),
                pt => pt.priceTypeId
              )
            : uniqBy(state.packageListing.packageDetail.priceTypeOverrideDictionary[PriceTypeOverrideType.ACQUISTION],
                pt => pt.priceTypeId),
    }
}

function mapDispatchToProps(dispatch, ownProps: QuantitySelectProps): DispatchToProps {
    return {
        selectPriceTypeQuantity: (ptId, quantity) => {
            dispatch(updatePriceTypeQuantity(ptId, quantity));
            dispatch(getUnseatedFlexPricingFromPt(quantity, ptId));
        },
        resetPriceTypeQuantities: () => {
            dispatch(clearPriceTypeQuantities());
        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(QuantitySelectBase);